import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Directive, Input, EventEmitter, Component, Output, Pipe, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { NestedTreeControl, CdkTreeModule } from '@angular/cdk/tree';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5 from '@angular/material/tree';
import { MatTreeNestedDataSource, MatTreeModule } from '@angular/material/tree';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i3 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { isNull } from 'common-utils/dist/typescript-utils';
import { SelectionModel } from '@angular/cdk/collections';

class VarDirective {
    constructor(vcRef, templateRef) {
        this.vcRef = vcRef;
        this.templateRef = templateRef;
        this.context = {};
    }
    set ngVar(context) {
        this.context.$implicit = this.context.ngVar = context;
        this.updateView();
    }
    updateView() {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
}
/** @nocollapse */ VarDirective.ɵfac = function VarDirective_Factory(t) { return new (t || VarDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef)); };
/** @nocollapse */ VarDirective.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: VarDirective, selectors: [["", "ngVar", ""]], inputs: { ngVar: "ngVar" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VarDirective, [{
        type: Directive,
        args: [{
                selector: '[ngVar]',
            }]
    }], function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, { ngVar: [{
            type: Input
        }] }); })();

function TreeSelectorComponent_mat_tree_node_1_span_3_span_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 12);
} if (rf & 2) {
    const icon_r4 = i0.ɵɵnextContext(2).ngVar;
    i0.ɵɵpropertyInterpolate2("svgIcon", "", icon_r4.namespace, ":", icon_r4.name, "");
} }
function TreeSelectorComponent_mat_tree_node_1_span_3_span_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r4 = i0.ɵɵnextContext(2).ngVar;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(icon_r4.name);
} }
function TreeSelectorComponent_mat_tree_node_1_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtemplate(1, TreeSelectorComponent_mat_tree_node_1_span_3_span_1_mat_icon_1_Template, 1, 2, "mat-icon", 10);
    i0.ɵɵtemplate(2, TreeSelectorComponent_mat_tree_node_1_span_3_span_1_mat_icon_2_Template, 2, 1, "mat-icon", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r4 = i0.ɵɵnextContext().ngVar;
    i0.ɵɵproperty("ngSwitch", icon_r4.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "svg");
} }
function TreeSelectorComponent_mat_tree_node_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, TreeSelectorComponent_mat_tree_node_1_span_3_span_1_Template, 3, 2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r4 = ctx.ngVar;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", icon_r4);
} }
function TreeSelectorComponent_mat_tree_node_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tree-node", 3)(1, "li", 4)(2, "mat-checkbox", 5);
    i0.ɵɵlistener("change", function TreeSelectorComponent_mat_tree_node_1_Template_mat_checkbox_change_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const node_r2 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.selectionToggle(node_r2)); });
    i0.ɵɵtemplate(3, TreeSelectorComponent_mat_tree_node_1_span_3_Template, 2, 1, "span", 6);
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const node_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r0.treeSelection.isSelected(node_r2))("disabled", !ctx_r0.isNodeSelectable(node_r2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngVar", ctx_r0.getIcon(node_r2));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("tree-node-expandable", false)("tree-node-expanded", ctx_r0.treeControl.isExpanded(node_r2) ? "true" : "false")("tree-node-disabled", ctx_r0.isNodeSelectable(node_r2) ? "false" : "true")("tree-node-selected", ctx_r0.treeSelection.isSelected(node_r2) ? "true" : "false");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", node_r2[ctx_r0.labelIdentifier], " ");
} }
function TreeSelectorComponent_mat_nested_tree_node_2_span_4_span_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 12);
} if (rf & 2) {
    const icon_r16 = i0.ɵɵnextContext(2).ngVar;
    i0.ɵɵpropertyInterpolate2("svgIcon", "", icon_r16.namespace, ":", icon_r16.name, "");
} }
function TreeSelectorComponent_mat_nested_tree_node_2_span_4_span_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r16 = i0.ɵɵnextContext(2).ngVar;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(icon_r16.name);
} }
function TreeSelectorComponent_mat_nested_tree_node_2_span_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtemplate(1, TreeSelectorComponent_mat_nested_tree_node_2_span_4_span_1_mat_icon_1_Template, 1, 2, "mat-icon", 10);
    i0.ɵɵtemplate(2, TreeSelectorComponent_mat_nested_tree_node_2_span_4_span_1_mat_icon_2_Template, 2, 1, "mat-icon", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r16 = i0.ɵɵnextContext().ngVar;
    i0.ɵɵproperty("ngSwitch", icon_r16.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "svg");
} }
function TreeSelectorComponent_mat_nested_tree_node_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, TreeSelectorComponent_mat_nested_tree_node_2_span_4_span_1_Template, 3, 2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r16 = ctx.ngVar;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", icon_r16);
} }
function TreeSelectorComponent_mat_nested_tree_node_2_ul_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵelementContainer(1, 17);
    i0.ɵɵelementEnd();
} }
function TreeSelectorComponent_mat_nested_tree_node_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-nested-tree-node")(1, "li")(2, "div", 4)(3, "mat-checkbox", 5);
    i0.ɵɵlistener("change", function TreeSelectorComponent_mat_nested_tree_node_2_Template_mat_checkbox_change_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r24); const node_r13 = restoredCtx.$implicit; const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.selectionToggle(node_r13)); });
    i0.ɵɵtemplate(4, TreeSelectorComponent_mat_nested_tree_node_2_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 14)(8, "mat-icon", 15);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, TreeSelectorComponent_mat_nested_tree_node_2_ul_10_Template, 2, 0, "ul", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const node_r13 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r1.treeSelection.isSelected(node_r13))("disabled", !ctx_r1.isNodeSelectable(node_r13));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngVar", ctx_r1.getIcon(node_r13));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("tree-node-expandable", true)("tree-node-expanded", ctx_r1.treeControl.isExpanded(node_r13) ? "true" : "false")("tree-node-disabled", ctx_r1.isNodeSelectable(node_r13) ? "false" : "true")("tree-node-selected", ctx_r1.treeSelection.isSelected(node_r13) ? "true" : "false");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", node_r13[ctx_r1.labelIdentifier], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", "toggle " + node_r13[ctx_r1.labelIdentifier]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.treeControl.isExpanded(node_r13) ? "expand_more" : "chevron_right", " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.treeControl.isExpanded(node_r13));
} }
const DEFAULT_ICON_DEFINITION = {
    Organization: {
        name: 'language',
        type: '',
        namespace: '',
    },
    SpaceGroup: {
        name: 'folder',
        type: '',
        namespace: '',
    },
    MeterGroup: {
        name: 'folder',
        type: '',
        namespace: '',
    },
    Site: {
        name: 'apartment',
        type: '',
        namespace: '',
    },
    Meter: {
        name: 'offline_bolt',
        type: '',
        namespace: '',
    },
};
const DISABLED_NODE_DEFINITION = {
    space_type: ['SpaceGroup', 'MeterGroup'],
};
class TreeSelectorComponent {
    constructor() {
        this._multiSelect = false;
        this._cascadeSelect = false;
        this._expandAll = false;
        this._dirSelectable = false;
        this._showSearch = true;
        this._allowDeselect = true;
        this._maxSelections = 0;
        this._iconIdentifier = 'space_type';
        this._iconDefinitions = DEFAULT_ICON_DEFINITION;
        this._disabledNodeDefinitions = DISABLED_NODE_DEFINITION;
        this._flattenedTree = [];
        this._defaultExpandedNodes = [];
        this._defaultSelectedNodes = [];
        this.treeControl = new NestedTreeControl(node => node.children);
        this.dataSource = new MatTreeNestedDataSource();
        this.labelIdentifier = 'display_label';
        this.selection = new EventEmitter();
        this.hasChild = (_, node) => !!node.children && node.children.length > 0;
        this.treeSelection = new SelectionModel(this.multiSelect);
        this.selection.emit(this.treeSelection);
    }
    set treeData(treeData) {
        if (isNull(treeData))
            return;
        treeData = this.addParentToTreeNodes(treeData);
        this.dataSource = new MatTreeNestedDataSource();
        this.dataSource.data = treeData;
        this.treeControl.dataNodes = treeData;
        if (this._expandAll) {
            this.treeControl.expandAll();
        }
    }
    set multiSelect(multiSelect) {
        if (isNull(multiSelect))
            return;
        let selected = [];
        if (this.treeSelection.selected && this.treeSelection.selected.length > 0) {
            if (!multiSelect) {
                selected = [this.treeSelection.selected[0]];
            }
            else {
                selected = [...this.treeSelection.selected];
            }
        }
        this.treeSelection.clear();
        this.treeSelection = new SelectionModel(multiSelect, []);
        this._multiSelect = multiSelect;
        this.selection.emit(this.treeSelection);
        if (selected) {
            if (Array.isArray(selected) && selected.length > 0) {
                this.treeSelection.select(...selected);
            }
            else if (!Array.isArray(selected)) {
                this.treeSelection.select(...[selected]);
            }
        }
    }
    set maxSelections(maxSelections) {
        if (isNull(maxSelections))
            return;
        this._maxSelections = maxSelections;
        if (this._multiSelect && this._maxSelections > 0) {
            let truncateNodes = this.treeSelection.selected.splice(this._maxSelections);
            this.treeSelection.deselect(...truncateNodes);
        }
    }
    set iconIdentifier(iconIdentifier) {
        if (isNull(iconIdentifier))
            return;
        this._iconIdentifier = iconIdentifier;
    }
    set iconDefinitions(iconDefinitions) {
        if (isNull(iconDefinitions))
            return;
        this._iconDefinitions = iconDefinitions;
    }
    set defaultSelectedNodes(defaultSelectedNodes) {
        if (isNull(defaultSelectedNodes))
            return;
        this._defaultSelectedNodes = defaultSelectedNodes;
        this.expandTo(this._defaultSelectedNodes, true);
    }
    set defaultExpandedNodes(defaultExpandedNodes) {
        if (isNull(defaultExpandedNodes))
            return;
        this._defaultExpandedNodes = defaultExpandedNodes;
        this.expandTo(this._defaultExpandedNodes, false, true);
    }
    set disabledNodeDefinitions(disabledNodeDefs) {
        if (isNull(disabledNodeDefs))
            return;
        this._disabledNodeDefinitions = disabledNodeDefs;
    }
    set cascadeSelect(cascadeSelect) {
        if (isNull(cascadeSelect))
            return;
        this._multiSelect ? (this._cascadeSelect = cascadeSelect) : (this._cascadeSelect = false);
    }
    set expandAll(expandAll) {
        if (isNull(expandAll))
            return;
        this._expandAll = expandAll;
        expandAll ? this.treeControl.expandAll() : this.treeControl.collapseAll();
    }
    ngOnInit() {
        this.expandTo(this._defaultExpandedNodes, false, true);
        this.expandTo(this._defaultSelectedNodes, true);
    }
    /** Toggle the to-do item selection. Select/deselect all the descendants node */
    selectionToggle(node, forceSelect) {
        const descendants = this.treeControl.getDescendants(node);
        if (this.treeSelection.isSelected(node) && !forceSelect) {
            this.treeSelection.deselect(node);
            if (this._multiSelect && this._cascadeSelect) {
                this.treeSelection.deselect(...descendants);
            }
        }
        else {
            if (this.isNodeSelectable(node)) {
                this.treeSelection.select(node);
                if (this.areDescendantsSelectable(node)) {
                    this.treeSelection.select(...descendants);
                }
            }
        }
    }
    isNodeSelectable(node) {
        if (this.isNodeDisabled(node)) {
            return false;
        }
        if (this.treeSelection.isSelected(node)) {
            return true;
        }
        return !this.isTreeAtMaxSelection();
    }
    isNodeDisabled(node) {
        if (isNull(this._disabledNodeDefinitions))
            return true;
        // Check if node has properties that match in _disabledNodeDefinitions
        let isDisabled = false;
        Object.keys(this._disabledNodeDefinitions).forEach((key) => {
            if (this._disabledNodeDefinitions && this._disabledNodeDefinitions[key]) {
                if (this._disabledNodeDefinitions[key].includes(node[key])) {
                    isDisabled = true;
                    if (this.treeSelection.isSelected(node)) {
                        this.treeSelection.deselect(node);
                    }
                    return;
                }
            }
        });
        return isDisabled;
    }
    isTreeAtMaxSelection() {
        let atMaxSelection = false;
        if (this._multiSelect && this._maxSelections > 0) {
            if (this.treeSelection.selected.length >= this._maxSelections) {
                atMaxSelection = true;
            }
        }
        return atMaxSelection;
    }
    areDescendantsSelectable(node) {
        if (!this._cascadeSelect) {
            return false;
        }
        if (this._cascadeSelect && this._maxSelections <= 0) {
            return true;
        }
        if (this.isTreeAtMaxSelection()) {
            return false;
        }
        const descendants = this.treeControl.getDescendants(node);
        return this.treeSelection.selected.length + descendants.length <= this._maxSelections;
    }
    getIcon(node) {
        return this._iconDefinitions[node[this._iconIdentifier]];
    }
    expandTo(nodeIds, selectNodes, expandSelf) {
        if (isNull(nodeIds) || !nodeIds.length)
            return;
        if (!Array.isArray(nodeIds)) {
            nodeIds = [nodeIds];
        }
        nodeIds.forEach(nodeId => {
            let expandToNode = this.getNodeById(nodeId);
            if (expandToNode) {
                if (expandToNode.parent && expandToNode.parent.length > 0) {
                    expandToNode.parent.forEach((parentNodeId) => {
                        this.expandNode(parentNodeId);
                    });
                }
                if (expandSelf) {
                    this.expandNode(expandToNode.id);
                }
                if (selectNodes) {
                    this.selectionToggle(expandToNode, true);
                }
            }
        });
    }
    expandNode(nodeId) {
        let expandNode = this.getNodeById(nodeId);
        if (expandNode && !this.treeControl.isExpanded(expandNode)) {
            this.treeControl.expand(expandNode);
        }
    }
    getNodeById(nodeId) {
        return this._flattenedTree.find((node) => {
            return node.id === nodeId;
        });
    }
    /** Whether all the descendants of the node are selected. */
    descendantsAllSelected(node) {
        const descendants = this.treeControl.getDescendants(node);
        return descendants.every(child => this.treeSelection.isSelected(child));
    }
    /** Whether part of the descendants are selected */
    descendantsPartiallySelected(node) {
        const descendants = this.treeControl.getDescendants(node);
        const result = descendants.some(child => this.treeSelection.isSelected(child));
        return result && !this.descendantsAllSelected(node);
    }
    /** Check root node checked state and change it accordingly */
    checkRootNodeSelection(node) {
        const nodeSelected = this.treeSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected = descendants.every(child => this.treeSelection.isSelected(child));
        if (nodeSelected && !descAllSelected) {
            this.treeSelection.deselect(node);
        }
        else if (!nodeSelected && descAllSelected) {
            this.treeSelection.select(node);
        }
    }
    addParentToTreeNodes(tree) {
        let nodeArray = Object.assign([], tree);
        let flatTree = [];
        while (nodeArray.length > 0) {
            let node = nodeArray.shift();
            if (node) {
                flatTree.push(node);
                node.parent = node.parent && Array.isArray(node.parent) ? node.parent : [];
                node.icon = this._iconDefinitions[node[this._iconIdentifier]] || null;
                if (node.children) {
                    let newChildren = [];
                    node.children.forEach((child) => {
                        if (node) {
                            child.parent = node.parent ? node.parent.slice(0) : [];
                            child.parent.push(node.id);
                            newChildren.push(child);
                        }
                    });
                    nodeArray.push(...newChildren);
                }
            }
        }
        this._flattenedTree = flatTree;
        console.log('Tree Size:', flatTree.length);
        return tree;
    }
}
/** @nocollapse */ TreeSelectorComponent.ɵfac = function TreeSelectorComponent_Factory(t) { return new (t || TreeSelectorComponent)(); };
/** @nocollapse */ TreeSelectorComponent.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TreeSelectorComponent, selectors: [["tree-selector"]], inputs: { treeData: "treeData", multiSelect: "multiSelect", maxSelections: "maxSelections", labelIdentifier: "labelIdentifier", iconIdentifier: "iconIdentifier", iconDefinitions: "iconDefinitions", defaultSelectedNodes: "defaultSelectedNodes", defaultExpandedNodes: "defaultExpandedNodes", disabledNodeDefinitions: "disabledNodeDefinitions", cascadeSelect: "cascadeSelect", expandAll: "expandAll" }, outputs: { selection: "selection" }, decls: 3, vars: 3, consts: [[1, "tree-selector", 3, "dataSource", "treeControl"], ["matTreeNodeToggle", "", 4, "matTreeNodeDef"], [4, "matTreeNodeDef", "matTreeNodeDefWhen"], ["matTreeNodeToggle", ""], [1, "mat-tree-node"], [1, "checklist-leaf-node", 3, "checked", "disabled", "change"], [4, "ngVar"], [1, "tree-node-label"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], ["aria-hidden", "true", 3, "svgIcon", 4, "ngSwitchCase"], ["aria-hidden", "true", 4, "ngSwitchDefault"], ["aria-hidden", "true", 3, "svgIcon"], ["aria-hidden", "true"], ["mat-icon-button", "", "matTreeNodeToggle", ""], [1, "mat-icon-rtl-mirror"], [4, "ngIf"], ["matTreeNodeOutlet", ""]], template: function TreeSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-tree", 0);
        i0.ɵɵtemplate(1, TreeSelectorComponent_mat_tree_node_1_Template, 6, 8, "mat-tree-node", 1);
        i0.ɵɵtemplate(2, TreeSelectorComponent_mat_nested_tree_node_2_Template, 11, 11, "mat-nested-tree-node", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("dataSource", ctx.dataSource)("treeControl", ctx.treeControl);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("matTreeNodeDefWhen", ctx.hasChild);
    } }, dependencies: [i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, i2.MatButton, i3.MatCheckbox, i4.MatIcon, i5.MatNestedTreeNode, i5.MatTreeNodeDef, i5.MatTreeNodeToggle, i5.MatTree, i5.MatTreeNode, i5.MatTreeNodeOutlet, VarDirective], styles: [".mat-tree[_ngcontent-%COMP%]{background-color:transparent}.tree-selector-invisible[_ngcontent-%COMP%]{display:none}.tree-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%], .tree-selector[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;list-style-type:none}mat-checkbox[_ngcontent-%COMP%]{width:calc(100% - 50px)}mat-checkbox[_ngcontent-%COMP%]     label.mat-checkbox-layout{width:100%}mat-checkbox[_ngcontent-%COMP%]     span.mat-checkbox-label{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;font-size:13px;width:100%;line-height:inherit}mat-checkbox[_ngcontent-%COMP%]     span.mat-checkbox-label span{display:inline-block;height:24px}mat-checkbox[_ngcontent-%COMP%]     span.mat-checkbox-label mat-icon{margin-right:2px}mat-checkbox[_ngcontent-%COMP%]     span.mat-checkbox-label mat-icon svg{stroke:#444;stroke-width:1px;padding:4px;box-sizing:border-box}.mat-checkbox-disabled[_ngcontent-%COMP%]     span.mat-checkbox-label mat-icon{color:rgba(0,0,0,.34)}mat-icon[_ngcontent-%COMP%]{color:rgba(0,0,0,.67);font-size:18px;line-height:24px}.mat-tree-node[_ngcontent-%COMP%]{margin-right:10px;min-height:30px;overflow:visible}.mat-tree-node[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{line-height:30px;margin-left:auto;width:30px;height:30px}.mat-nested-tree-node[_ngcontent-%COMP%]     ul{padding-left:20px}.mat-nested-tree-node[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style:none;width:100%}.tree-node-label[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:24px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TreeSelectorComponent, [{
        type: Component,
        args: [{ selector: 'tree-selector', template: "<mat-tree [dataSource]=\"dataSource\" [treeControl]=\"treeControl\" class=\"tree-selector\">\n    <!-- This is the tree node template for leaf nodes -->\n    <mat-tree-node *matTreeNodeDef=\"let node\" matTreeNodeToggle>\n        <li class=\"mat-tree-node\">\n            <mat-checkbox\n                class=\"checklist-leaf-node\"\n                [checked]=\"treeSelection.isSelected(node)\"\n                (change)=\"selectionToggle(node)\"\n                [disabled]=\"!isNodeSelectable(node)\"\n            >\n                <span *ngVar=\"getIcon(node) as icon\">\n                    <span *ngIf=\"icon\" [ngSwitch]=\"icon.type\">\n                        <mat-icon\n                            *ngSwitchCase=\"'svg'\"\n                            aria-hidden=\"true\"\n                            svgIcon=\"{{ icon.namespace }}:{{ icon.name }}\"\n                        ></mat-icon>\n                        <mat-icon *ngSwitchDefault aria-hidden=\"true\">{{ icon.name }}</mat-icon>\n                    </span>\n                </span>\n                <span\n                    class=\"tree-node-label\"\n                    [attr.tree-node-expandable]=\"false\"\n                    [attr.tree-node-expanded]=\"treeControl.isExpanded(node) ? 'true' : 'false'\"\n                    [attr.tree-node-disabled]=\"isNodeSelectable(node) ? 'false' : 'true'\"\n                    [attr.tree-node-selected]=\"treeSelection.isSelected(node) ? 'true' : 'false'\"\n                >\n                    {{ node[labelIdentifier] }}\n                </span>\n            </mat-checkbox>\n        </li>\n    </mat-tree-node>\n\n    <!-- This is the tree node template for expandable nodes -->\n    <mat-nested-tree-node *matTreeNodeDef=\"let node; when: hasChild\">\n        <li>\n            <div class=\"mat-tree-node\">\n                <mat-checkbox\n                    class=\"checklist-leaf-node\"\n                    [checked]=\"treeSelection.isSelected(node)\"\n                    (change)=\"selectionToggle(node)\"\n                    [disabled]=\"!isNodeSelectable(node)\"\n                >\n                    <span *ngVar=\"getIcon(node) as icon\">\n                        <span *ngIf=\"icon\" [ngSwitch]=\"icon.type\">\n                            <mat-icon\n                                *ngSwitchCase=\"'svg'\"\n                                aria-hidden=\"true\"\n                                svgIcon=\"{{ icon.namespace }}:{{ icon.name }}\"\n                            ></mat-icon>\n                            <mat-icon *ngSwitchDefault aria-hidden=\"true\">{{ icon.name }}</mat-icon>\n                        </span>\n                    </span>\n                    <span\n                        class=\"tree-node-label\"\n                        [attr.tree-node-expandable]=\"true\"\n                        [attr.tree-node-expanded]=\"treeControl.isExpanded(node) ? 'true' : 'false'\"\n                        [attr.tree-node-disabled]=\"isNodeSelectable(node) ? 'false' : 'true'\"\n                        [attr.tree-node-selected]=\"treeSelection.isSelected(node) ? 'true' : 'false'\"\n                    >\n                        {{ node[labelIdentifier] }}\n                    </span>\n                </mat-checkbox>\n                <button mat-icon-button matTreeNodeToggle [attr.aria-label]=\"'toggle ' + node[labelIdentifier]\">\n                    <mat-icon class=\"mat-icon-rtl-mirror\">\n                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}\n                    </mat-icon>\n                </button>\n            </div>\n            <ul *ngIf=\"treeControl.isExpanded(node)\">\n                <ng-container matTreeNodeOutlet></ng-container>\n            </ul>\n        </li>\n    </mat-nested-tree-node>\n</mat-tree>\n", styles: [".mat-tree{background-color:transparent}.tree-selector-invisible{display:none}.tree-selector ul,.tree-selector li{margin-top:0;margin-bottom:0;list-style-type:none}mat-checkbox{width:calc(100% - 50px)}mat-checkbox ::ng-deep label.mat-checkbox-layout{width:100%}mat-checkbox ::ng-deep span.mat-checkbox-label{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;font-size:13px;width:100%;line-height:inherit}mat-checkbox ::ng-deep span.mat-checkbox-label span{display:inline-block;height:24px}mat-checkbox ::ng-deep span.mat-checkbox-label mat-icon{margin-right:2px}mat-checkbox ::ng-deep span.mat-checkbox-label mat-icon svg{stroke:#444;stroke-width:1px;padding:4px;box-sizing:border-box}.mat-checkbox-disabled ::ng-deep span.mat-checkbox-label mat-icon{color:rgba(0,0,0,.34)}mat-icon{color:rgba(0,0,0,.67);font-size:18px;line-height:24px}.mat-tree-node{margin-right:10px;min-height:30px;overflow:visible}.mat-tree-node>button{line-height:30px;margin-left:auto;width:30px;height:30px}.mat-nested-tree-node ::ng-deep ul{padding-left:20px}.mat-nested-tree-node li{list-style:none;width:100%}.tree-node-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:24px}\n"] }]
    }], function () { return []; }, { treeData: [{
            type: Input
        }], multiSelect: [{
            type: Input
        }], maxSelections: [{
            type: Input
        }], labelIdentifier: [{
            type: Input
        }], iconIdentifier: [{
            type: Input
        }], iconDefinitions: [{
            type: Input
        }], defaultSelectedNodes: [{
            type: Input
        }], defaultExpandedNodes: [{
            type: Input
        }], disabledNodeDefinitions: [{
            type: Input
        }], cascadeSelect: [{
            type: Input
        }], expandAll: [{
            type: Input
        }], selection: [{
            type: Output
        }] }); })();

class FilterPipe {
    transform(value, searchText) {
        if (searchText) {
            searchText = searchText.toLowerCase();
            return value.filter(function (el) {
                return el.display_label.toLowerCase().indexOf(searchText) > -1;
            });
        }
        return value;
    }
}
/** @nocollapse */ FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
/** @nocollapse */ FilterPipe.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], null, null); })();

class TreeSelectorModule {
    static forRoot(config) {
        return {
            ngModule: TreeSelectorModule,
            providers: [
            // { provide: NAMESPACE_TOKEN, useValue: config.namespace },
            ],
        };
    }
}
/** @nocollapse */ TreeSelectorModule.ɵfac = function TreeSelectorModule_Factory(t) { return new (t || TreeSelectorModule)(); };
/** @nocollapse */ TreeSelectorModule.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: TreeSelectorModule });
/** @nocollapse */ TreeSelectorModule.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        HttpClientModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        CdkTreeModule,
        MatIconModule,
        MatTreeModule,
        BrowserAnimationsModule,
        TranslateModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TreeSelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    HttpClientModule,
                    MatButtonModule,
                    MatButtonToggleModule,
                    MatCheckboxModule,
                    CdkTreeModule,
                    MatIconModule,
                    MatTreeModule,
                    BrowserAnimationsModule,
                    TranslateModule,
                ],
                declarations: [TreeSelectorComponent, FilterPipe, VarDirective],
                exports: [TreeSelectorComponent],
                providers: [
                // { provide: NAMESPACE_TOKEN, useValue: '' },
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TreeSelectorModule, { declarations: [TreeSelectorComponent, FilterPipe, VarDirective], imports: [CommonModule,
        FormsModule,
        HttpClientModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        CdkTreeModule,
        MatIconModule,
        MatTreeModule,
        BrowserAnimationsModule,
        TranslateModule], exports: [TreeSelectorComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TreeSelectorComponent, TreeSelectorModule };
